import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, Grid, Tab, TextField } from '@mui/material';
import MetricWidget from './metricWidget';
import { AWSResources, LambdaMetrics, DynamoDBMetrics, SQSMetrics, TimestreamMetrics, MetricStates } from '../../types/MetricWidgetTypes';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useModularTimePeriodSelector } from '../../hooks/useModularTimePeriodSelector';
import DimensionSelector from './resourceDimensionSelector';
const debug = process.env.REACT_APP_DEBUG && false;
const CloudWatchView = ({}) => {
    const [resourceTabValue, setResourceTabValue] = useState(AWSResources.Lambda);
    const [selectedResource, setSelectedResource] = useState(resourceTabValue);
    const [resourceMetric, setResourceMetric] = useState(null);
    const [metricState, setMetricState] = useState(null);
    const [selectedDimensionMapList, setSelectedDimensionMapList] = useState([]);
    const { components: timeSelectorComponents, fromDateValue, toDateValue, } = useModularTimePeriodSelector({ rangeUnit: 'hours', rangeLength: 1, requireConfirmation: true });
    const resourceOptions = Object.keys(AWSResources);
    const metricStateOptions = Object.keys(MetricStates);
    const getResourceMetricOptions = (resourceName) => {
        switch (resourceName) {
            case 'Lambda':
                return Object.keys(LambdaMetrics);
            case 'DynamoDB':
                return Object.keys(DynamoDBMetrics);
            case 'SQS':
                return Object.keys(SQSMetrics);
            case 'Timestream':
                return Object.keys(TimestreamMetrics);
            default:
                return [];
        }
    };
    useEffect(() => {
        if (!resourceMetric) {
            debug && console.log(`resourceMetric now is ${resourceMetric}, reset SelectedDimensionMapList`);
            setSelectedDimensionMapList([]);
        }
    }, [resourceMetric]);
    return (_jsxs("div", { children: [_jsx(Grid, { container: true, spacing: 2, sx: {
                    alignItems: 'center',
                }, children: _jsx(Grid, { size: 12, children: timeSelectorComponents.TimePeriodSelector }) }), _jsxs(TabContext, { value: resourceTabValue, children: [_jsx(Box, { sx: { borderBottom: 1, borderColor: 'divider' }, children: _jsx(TabList, { onChange: (event, newValue) => {
                                setResourceTabValue(newValue);
                                setSelectedResource(newValue);
                                setResourceMetric(null);
                                setMetricState(null);
                                setSelectedDimensionMapList([]);
                            }, children: resourceOptions.map((resource) => (_jsx(Tab, { label: resource, value: resource, sx: { textTransform: 'none' } }, resource))) }) }), resourceOptions.map((resource) => {
                        return (_jsx(TabPanel, { value: resource, children: _jsx(Box, { sx: { flexGrow: 1 }, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: 6, children: _jsx(Autocomplete, { options: getResourceMetricOptions(resource), onChange: (event, newValue) => {
                                                    setResourceMetric(newValue);
                                                }, renderInput: (params) => _jsx(TextField, { ...params, label: "MetricType" }) }) }), _jsx(Grid, { size: 6, children: _jsx(Autocomplete, { options: metricStateOptions, onChange: (event, newValue) => setMetricState(newValue), renderInput: (params) => _jsx(TextField, { ...params, label: "MetricState" }) }) }), selectedResource && resourceMetric && metricState && _jsx(DimensionSelector, { resource, resourceMetric, setSelectedDimensionMapList }), selectedResource && resourceMetric && metricState && fromDateValue && toDateValue && selectedDimensionMapList.length > 0 && (
                                        // selectedDimensionMapList.map((map) => {
                                        //   return (
                                        //     <Grid item xs>
                                        //       <>index: {selectedDimensionMapList.indexOf(map)}</>
                                        //       <br />
                                        //       <>dimensionName: {map.dimensionName}</>
                                        //       <br />
                                        //       <>dimensionValue: {map.dimensionValue}</>
                                        //     </Grid>
                                        //   )
                                        // })
                                        _jsxs(Grid, { size: 12, children: [_jsx("br", {}), _jsx(MetricWidget, { resource: selectedResource,
                                                    metricName: resourceMetric,
                                                    metricState,
                                                    selectedDimensionMapList,
                                                    start: fromDateValue,
                                                    end: toDateValue })] }))] }) }) }, resource));
                    })] })] }));
};
export default CloudWatchView;
